<template>
    <div class="searchContent">
        <div class="searchView">
            <SearchField v-if='$root.showContextSearch'></SearchField> 
            <SearchForm v-if='!$root.showContextSearch'></SearchForm>
        </div>
    </div>
</template>

<script>
import SearchField from "../components/Search/SearchField.vue"
import SearchForm from "../components/Search/SearchForm.vue"

export default {
    name: "Search",
    components: {
        SearchField,
        SearchForm
    },
    methods: {

    }
}
</script>

<style lang="scss" src="@/assets/css/views/Search.scss"></style>